import { ReactNode, useEffect } from 'react';

import { ThemeProvider } from '@material-ui/core';

import {
  encoreDarkTheme,
  encoreLightTheme,
} from '@spotify/confidence-backstage-encore-theme';

import { useBUITheme } from './useBUITheme';

function useEncoreVariant() {
  useEffect(() => {
    document.body.setAttribute('data-theme-variant', 'encore');
    return () => {
      document.body.removeAttribute('data-theme-variant');
    };
  }, []);
}

export const EncoreDarkThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('dark');
  useEncoreVariant();

  return <ThemeProvider theme={encoreDarkTheme}>{children}</ThemeProvider>;
};

export const EncoreLightThemeProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  useBUITheme('light');
  useEncoreVariant();

  return <ThemeProvider theme={encoreLightTheme}>{children}</ThemeProvider>;
};
